import { useNotify, useRefresh, required, TextInput, Button } from "react-admin";
import { candidateRequests } from "api/candidateApi";
import { settings } from "app";
import AddIcon from "@mui/icons-material/Add";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const ManageNoteDialog = ({
  candidacyId,
  currentNote,
  disabled,
  source = "note.note",
  label = "Добави",
  startIcon = <AddIcon />,
  resource = candidateRequests.updateCandidacyNote(candidacyId),
}) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const note = source.split(".").reduce((obj, key) => obj?.[key], data);
    await dataProvider.customRequest(resource, { note }, "PUT");
    notify("Успешно добавяне", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent={currentNote ? "Редактиране на бележка" : "Добавяне на бележка"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label={label}
          disabled={disabled}
          startIcon={startIcon}
          variant="contained"
        />
      }
    >
      <TextInput
        source={source}
        defaultValue={currentNote}
        label="Бележка"
        sx={settings.style.textAria}
        variant="outlined"
        fullWidth
        multiline
        minRows={1}
        maxRows={12}
        validate={[required()]}
      />
    </FormModal>
  );
};

export default ManageNoteDialog;
